export default __webpack_public_path__ + "static/spitz-nextImage-7f6c40aadc75368fc6b95f70b903503c.jpg";